import React from 'react'
import PropTypes from 'prop-types'
import { displayAttribute, formatDate } from 'utils'
import { StatusBadge } from 'components'

const propTypes = {
  name: PropTypes.string,
  portalAgreementStatus: PropTypes.string,
  createdDate: PropTypes.string,
  planNumber: PropTypes.string,
  providerPlanId: PropTypes.string,
  portalAgreementType: PropTypes.string,
  planType: PropTypes.string,
  planStatus: PropTypes.string,
}
const defaultProps = {
  name: null,
  portalAgreementStatus: null,
  createdDate: null,
  planNumber: null,
  providerPlanId: null,
  portalAgreementType: null,
  planType: null,
  planStatus: null,
}
function AgreementDetailsBody({
  name,
  portalAgreementStatus,
  createdDate,
  planNumber,
  providerPlanId,
  portalAgreementType,
  planType,
  planStatus,
}) {
  return (
    <div className="order-details-container">
      <dl>
        <div className="order-details-column">
          <dt>Plan name</dt>
          <dd>{displayAttribute(name)}</dd>
        </div>
        <div className="order-details-column">
          <dt>Agreement status</dt>
          <dd>
            <StatusBadge status={portalAgreementStatus} />
          </dd>
        </div>
        <div className="order-details-column">
          <dt>Date created</dt>
          <dd>{displayAttribute(formatDate(createdDate))}</dd>
        </div>
        <div className="order-details-column">
          <dt>Three-digit plan number (PN)</dt>
          <dd>{displayAttribute(planNumber)}</dd>
        </div>
        <div className="order-details-column">
          <dt>Provider plan ID #</dt>
          <dd>{displayAttribute(providerPlanId)}</dd>
        </div>
        <div className="order-details-column">
          <dt>Initial investment</dt>
          <dd>{displayAttribute(portalAgreementType)}</dd>
        </div>
        <div className="order-details-column">
          <dt>Plan type</dt>
          <dd>{displayAttribute(planType)}</dd>
        </div>
        <div className="order-details-column">
          <dt>Plan status</dt>
          <dd>{displayAttribute(planStatus)}</dd>
        </div>
      </dl>
    </div>
  )
}
AgreementDetailsBody.propTypes = propTypes
AgreementDetailsBody.defaultProps = defaultProps

export default AgreementDetailsBody
